
// This constructor generates the Login form
export class Login {

  constructor(
	public username: string,
	public password: string
  ) {}

}

export class Recovery {
	constructor(
		public username: string,
		public email: string
	) {}
}


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/models/login.constructor.ts